module.exports = __webpack_public_path__ + "img/feature_ca_bg.ce48cf95.png";